import React, { useMemo, useState } from 'react';

// Backend API base for MCP config snippet users copy. Env-driven so migration
// of the backend hostname is a one-line change at build time.
const API_BASE =
  process.env.REACT_APP_TAGGING_API_URL || 'https://api.railtech.io';

/**
 * Tabbed code block: MCP config for Claude Desktop, Claude Code, Cursor.
 */
function McpTabs() {
  const tabs = useMemo(() => {
    const configJson = `{
  "mcpServers": {
    "mme": {
      "url": "${API_BASE}/mcp/http",
      "headers": {
        "Authorization": "Bearer YOUR_API_KEY"
      }
    }
  }
}`;
    return [
      {
        id: 'claude-desktop',
        label: 'Claude Desktop',
        path: '~/Library/Application Support/Claude/claude_desktop_config.json',
        code: configJson,
      },
      {
        id: 'claude-code',
        label: 'Claude Code',
        path: '~/.claude/mcp.json',
        code: configJson,
      },
      {
        id: 'cursor',
        label: 'Cursor',
        path: '~/.cursor/mcp.json',
        code: configJson,
      },
    ];
  }, []);

  const [active, setActive] = useState(tabs[0].id);
  const current = tabs.find((t) => t.id === active);

  // Simple JSON highlighter — keys in accent, strings in green.
  const highlighted = current.code
    .replace(/"([^"]+)"(\s*:)/g, '<span class="k">"$1"</span>$2')
    .replace(/:\s*"([^"]+)"/g, ': <span class="s">"$1"</span>');

  return (
    <div>
      <div className="tabs">
        {tabs.map((t) => (
          <button
            key={t.id}
            className={`tab ${t.id === active ? 'active' : ''}`}
            onClick={() => setActive(t.id)}
            type="button"
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="code-wrap">
        <div
          style={{
            padding: '10px 18px',
            borderBottom: '1px solid #1a1a1a',
            fontFamily: 'var(--mono)',
            fontSize: 11,
            color: '#8A8A83',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span>{current.path}</span>
          <span style={{ color: '#6A6A64' }}>json</span>
        </div>
        <pre
          className="code"
          style={{ margin: 0 }}
          dangerouslySetInnerHTML={{ __html: highlighted }}
        />
      </div>
      <div
        style={{
          marginTop: 12,
          fontSize: 13,
          color: 'var(--ink-3)',
          lineHeight: 1.6,
        }}
      >
        Same config for every client. One memory store — switch tools, your
        context comes with you.
      </div>
    </div>
  );
}

export default McpTabs;
